import { Box, Button, Container, Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MainContainer } from '../styles';
import { ProductsListContext } from '../contexts/ProductsListContext';
import { getProducts } from '../api/products';
import { PAGES_SLUGS } from '../variables';
import { ModalActions } from '../components/Modal';
import ProductCustomizeCard from '../components/ProductCard/ProductCustomizeCard';
import UploadFileCard from './UploadCard';
import PrivateLabelResume from './PrivateLabelResume';

const PrivateLabel = () => {
  const { t } = useTranslation();

  const [selectedIndex, setSelectedIndex] = useState(null);// usado para adicionar a border
  const [history, setHistory] = useState([]);
  const [step, setStep] = useState(1);
  console.log('History: ', history);
  console.log('Step: ', step);


  const handleNext = (selectedValue, isFile = false) => {
    const value = isFile
      ? {
        name: t(`privatelabel.steps.${step}`),
        title: selectedValue.name,
        type: selectedValue.type,
        file: selectedValue
      }
      : selectedValue;

    setHistory(prev => [...prev, value]);

    if (step === 4 && selectedIndex === 1) {
      setStep(prev => prev + 2);
    } else {
      setStep(prev => prev + 1);
    }

    setSelectedIndex(null);
  };

  const handleBack = () => {
    setHistory(prev => prev.slice(0, -1)); // pop último
    if (step === 6 && history[3].title.toLowerCase().includes('curta')) {
      setStep(prev => prev - 2);
    } else {
      setStep(prev => prev - 1);
    }
    if(step === 10 && history.find((element) => element.name && element.name === 'Etiqueta')){
      setHistory(prev => prev.slice(0,-1));
    }
  };
  const {
    products, setProducts, navigate, setIsLoading
  } = useContext(ProductsListContext);
  if (!products) throw new Error('ProductsListContext deve ser usado dentro de ProductsListProvider');

  useEffect(() => {
    if (step === null || step === 10) return;

    setIsLoading(true);

    getProducts({
      searchParams: {
        season: 'Configurador',
        collection: t(`privatelabel.steps.${step}`).toUpperCase()
      }
    })
      .then(({ displayedProducts, productsTotal }) => {
        if (step === 9 && history.length > 4) {
          if (history[3].title.toLowerCase().includes('curta')) {
            displayedProducts = displayedProducts.filter((element) => !element.title.toLowerCase().includes('punho'));
          }
        }
        setProducts({
          list: displayedProducts,
          total: productsTotal
        });
        setIsLoading(false);
      })
      .catch(({ response: { status } }) => {
        if (status === 401) navigate('/login');
        if (status === 400 || status > 401)
          navigate(PAGES_SLUGS.notFound, { replace: true });
        setIsLoading(false);
      });

  }, [step]);
  return (
    <MainContainer>
      <Container>
        <Grid container>
          <Grid xs={12}>
            <Box
              sx={{
                textAlign: 'center'
              }}
            >
              <Typography variant="h3">{t('privatelabel.title')}</Typography>
              <Typography variant="h3" marginTop={2}>
                {step !== 10
                  ? `${t('privatelabel.subtitle')} ${t(`privatelabel.steps.${step}`)}`
                  : t(`privatelabel.steps.${step}`)
                }
              </Typography>
            </Box>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                flexWrap: 'wrap',
                width: '100%',
                'justify-content': 'center',
                'margin': '16px 0 36px 0',
                gap: 2
              }}
            >
              <ModalActions>
                <Button
                  variant="contained"
                  title={t('privatelabel.back')}
                  disabled={step === 1}
                  onClick={() => handleBack()}
                  sx={{
                    width: '100%',
                    maxWidth: '100px'
                  }}>
                  {t('privatelabel.back')}
                </Button>
              </ModalActions>
              <Typography marginTop={2}>{step} de 10</Typography>
              <ModalActions>
                <Button
                  variant="contained"
                  title={t('privatelabel.next')}
                  disabled={step === 10 | selectedIndex === null}
                  onClick={() => handleNext(products.list[selectedIndex], false)}
                  sx={{
                    width: '100%',
                    maxWidth: '100px'
                  }}>
                  {t('privatelabel.next')}
                </Button>
              </ModalActions>
            </Box>
          </Grid>
        </Grid>
        {step !== 10 ? (
          <Grid spacing={5} sx={{
            display: 'grid',
            'grid-template-columns': {
              xs: 'repeat(2, 1fr)', // mobile (ex: 2 colunas)
              sm: 'repeat(3, 1fr)', // small tablets
              md: 'repeat(4, 1fr)', // tablets landscape / small desktops
              lg: 'repeat(5, 1fr)' // desktops grandes
            },
            'gap': '20px'
          }}>
            {step !== 4 && (
              <Grid item xs={6} sm={4} md={3}>
                <UploadFileCard
                  resetSignal={step}
                  onFileSelect={(file) => {
                    setTimeout(() =>  handleNext(file, true), 4000);
                  }}
                />


              </Grid>
            )}
            {products.list.map((product, index) => (
              <Grid
                key={`product-card-${product.reference}-${index}`}
                xs={12}
                md={3}
                onClick={() => setSelectedIndex(index)}
                sx={{
                  border: selectedIndex === index ? '1px solid black' : '1px solid #DDD',
                  borderRadius: 1,
                  cursor: 'pointer',
                  transition: 'border 0.2s'
                }}

              >
                <ProductCustomizeCard
                  product={product}
                />
              </Grid>
            ))}
          </Grid>
        ) : (
          <PrivateLabelResume products={history} />
        )}
      </Container>
    </MainContainer>
  )
    ;
};

export default PrivateLabel;
